<div class="user-account-page-wrapper">
  <dx-load-panel
  [hideOnOutsideClick]="false"
  shadingColor="rgba(0,0,0,0.4)"
  [(visible)]="loading">
</dx-load-panel>
<div class="page-wrapper">
  <div class="container">
    <form [formGroup]="customerForm">
      <app-panel [footer]="true" class="mb-3" [backArrow]="true">
        <div class="heading">{{customerContactLoginId ? 'Edit Customer Contact Login' : 'Add Customer Contact Login'}}</div>
          <div class="body">
            <div class="row">
              <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="dx-field">
                    <div>Username <span>*</span>:</div>
                    <dx-text-box [inputAttr]="{ autocomplete: 'off' }"  placeholder="Username" formControlName="userName">
                        <dx-validator>
                            <dxi-validation-rule type="required"
                                message="Username is required"></dxi-validation-rule>
                        </dx-validator>
                    </dx-text-box>
                </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-12">
                  <div class="dx-field">
                      <div>Password <span>*</span>:</div>
                      <dx-text-box [inputAttr]="{ autocomplete: 'off' }"  mode="password" placeholder="Password" formControlName="userPassword">
                          <dx-validator>
                              <dxi-validation-rule type="required" message="Password is required"></dxi-validation-rule>
                              <dxi-validation-rule type="pattern" [pattern]="passwordPattern" message="Invalid Password format, must contain atleast 8 characters with one special character and 1 number"></dxi-validation-rule>
                          </dx-validator>
                      </dx-text-box>
                  </div>
              </div>
              <div class="col-lg-4 col-md-4 col-sm-12">
                <div class="dx-field">
                  <div>Select Branchs <span>*</span>:</div>
                  <dx-tag-box [items]="customerBranches" placeholder="Choose Color"
                  displayExpr="branchName" valueExpr="customerBranchId"
                  formControlName="customerBranchList" [acceptCustomValue]="true"
                  [hideSelectedItems]="true" [searchEnabled]="true" [disabled]="customerBranches?.length == 0">
              </dx-tag-box>
                </div>
              </div>
            </div>
          </div>
          <div class="footer">
            <div class="float-left mt-2" *ngIf="customerContactLoginId">
              Active <dx-check-box formControlName="active"></dx-check-box>
            </div>
            <div class="float-left mt-2 ml-2">
              Administrator <dx-check-box  formControlName="isAdmin"></dx-check-box>
            </div>  
            <div class="float-right">
              <dx-button id="button" text="Save" type="default" 
                (click)="!customerForm.valid || addCustomerContactLogin(customerForm)"
                [useSubmitBehavior]="true">
              </dx-button>
            </div>
          </div>
      </app-panel>     
    </form>
  </div>
</div>
</div>
<swal #saveSwal></swal>  